export const BaseUrl = "https://app.planman.in"
// export const BaseUrl = "https://devapp.planman.in"
// export const BaseUrl = "http://127.0.0.1:8000"
// export const BaseUrl = "http://192.168.0.103:8000"